import clsx from "clsx";
import { motion } from "motion/react";
import type { ClassNameProps } from "../types";

/** Props Interface */
interface SkeletonProps extends ClassNameProps {
	placeholder?: string;
}

export function Skeleton({ placeholder = "SKELETON", className }: SkeletonProps) {
	/** Render */
	return (
		<motion.div
			className={clsx("stripes", "rounded-sm", "inline-block w-max", className)}
			animate={{
				opacity: [1, 0.5, 1],
			}}
			transition={{
				duration: 1,
				repeat: Number.POSITIVE_INFINITY,
				ease: "easeInOut",
			}}
		>
			{placeholder && <p className="opacity-0 select-none">{placeholder}</p>}
		</motion.div>
	);
}
